import { ArticleHeading4, UIText2 } from '@cian/ui-kit';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './SeoCrossLinks.css';
import { capitalize } from './utis/capitalize';
import { useSeoBlockCollapse } from './utis/useSeoBlockCollapse';
import { ICrossLinks } from '../../containers/SeoCrossLinksContainer/types';

interface ISeoLinksProps {
  seoBlocks: ICrossLinks[];
  maxRows?: number;
}

const LocalMarkup = {
  Link: ({ href, text }: { href: string; text: string }) => (
    <a className={styles['link']} href={href} title={text}>
      {text}
    </a>
  ),
};

interface ISeoCrossLinksBlockProps {
  seoBlock: ICrossLinks;
  maxRows: number;
}

function SeoCrossLinksBlock({ seoBlock, maxRows }: ISeoCrossLinksBlockProps) {
  const linkCount = seoBlock.links.length;
  const { containerRef, collapsedHeightPx, canExpand, expanded, setExpanded } = useSeoBlockCollapse(linkCount, maxRows);

  const showCollapsed = canExpand && !expanded && collapsedHeightPx !== null;

  return (
    <div className={styles['section']}>
      <div className={styles['heading']}>
        <ArticleHeading4 as="h4">{capitalize(seoBlock.title)}</ArticleHeading4>
      </div>
      <div className={styles['grid-outer']} style={showCollapsed ? { maxHeight: `${collapsedHeightPx}px` } : undefined}>
        <ul className={styles['grid']} ref={containerRef}>
          {seoBlock.links.map((link, linkIndex) => (
            <li key={`${seoBlock.title}-${linkIndex}`}>
              <LocalMarkup.Link href={link.uri} text={link.name} />
            </li>
          ))}
        </ul>
      </div>
      {canExpand && (
        <div className={styles['expand-row']}>
          <button
            type="button"
            className={styles['expand-button']}
            onClick={() => setExpanded(v => !v)}
            aria-expanded={expanded}
          >
            <UIText2 color={'text-primary-default'}>{expanded ? 'Свернуть' : 'Развернуть'}</UIText2>
            {expanded ? (
              <IconActionChevronUpSmall16 color="text-primary-default" />
            ) : (
              <IconActionChevronDownSmall16 color="text-primary-default" />
            )}
          </button>
        </div>
      )}
    </div>
  );
}

export function SeoCrossLinks({ seoBlocks, maxRows = 3 }: ISeoLinksProps) {
  return (
    <div className={styles['container']} data-name="SeoCrossLinksV2Preview">
      {seoBlocks.map((seoBlock, blockIndex) => (
        <SeoCrossLinksBlock key={`${seoBlock.title}-${blockIndex}`} seoBlock={seoBlock} maxRows={maxRows} />
      ))}
    </div>
  );
}
